import { action, observable } from 'mobx'
import { mustBeInRange } from '@/utils/validx-util'
import { required, validationContext } from 'validx'

/**
 * View Model for Bundle Price.
 */
export class PriceEditorViewModel {
  /**
   * The client amount for the Bundle. This is the amount the client will
   * be charged.
   */
  @observable accessor price = 0

  /**
   * Validation context.
   */
  readonly validation = validationContext(this, {
    price: [
      required('A bundle price is required.'),
      mustBeInRange(0, Infinity, 'The amount must be zero or greater.'),
    ],
  })

  /**
   * Validates the price, returning whether it is valid.
   */
  validate(): boolean {
    return this.validation.reset().validate().isValid
  }

  /**
   * Fills the editor with an existing price.
   */
  @action.bound
  hydrate(price: number): void {
    this.price = price
  }

  /**
   * The edited price.
   */
  toValue(): number {
    return this.price
  }

  /**
   * Clears the price and its validation errors.
   */
  @action.bound
  reset() {
    this.price = 0
    this.validation.reset()
  }
}
